export class SubProjectsUnderParentProjectModel {
    constructor() {
        this.name = "";
        this.createdOnAsString = "";
        this.description = "";
        this.profileImageUrl = "";
        this.employeeName = "";
        this.isSubProjectMember = true;
    }
}
export default class SubProjectsUnderParentProject extends SubProjectsUnderParentProjectModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
